import { getCookie, setCookie } from 'cookies-next';
import { generateGUID } from '@/lib/generate-guid';

const COOKIE_SESSION = 'session.userInfo';
const COOKIE_TRACKING = 'userTrackingId';

export function syncUserTrackingIdClient() {
  const sessionRaw = getCookie(COOKIE_SESSION);
  let fromSession: string | undefined;

  if (sessionRaw && typeof sessionRaw === 'string') {
    try {
      const parsed = JSON.parse(sessionRaw);
      fromSession = parsed?.userTrackingId;
    } catch {
      console.warn('Could not parse userInfo.userTrackingId from cookie');
    }
  }

  const existing = getCookie(COOKIE_TRACKING);

  if (!existing) {
    const id = fromSession ?? generateGUID();
    setCookie(COOKIE_TRACKING, id, { path: '/' });
  } else if (fromSession && fromSession !== existing) {
    setCookie(COOKIE_TRACKING, fromSession, { path: '/' });
  }
}
